import GMTDateFormatter from './DateFormatter/GMTDateFomatter'
import UTCDateFormatter from './DateFormatter/UTCDateFomatter'

/** Local day key (`YYYY-MM-DD`) - the day space the planting calendar and the offline trees list copy count in */
export function plantingDay(value: string | number | Date): string {
  const date = new Date(value);
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
}

export function formatDateFromDateString (date: string) {
  const dateObj = new Date(GMTDateFormatter.parseDate(date));
  return GMTDateFormatter.formatDate(dateObj);
}

export function formatDateFromTimestamp(date: number) {
  return GMTDateFormatter.formatDateFromTimestamp(date);
}

export function formatUTCDateFromDateString (date: string) {
  const dateObj = new Date(UTCDateFormatter.parseDate(date));
  return UTCDateFormatter.formatDate(dateObj);
}
